import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AdminAuthService } from '../services/admin-auth.service';

export const adminAuthInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AdminAuthService);
  const router = inject(Router);
  const token = auth.getAccessToken();
  const isAdminRequest = request.url.startsWith(`${environment.api}/admin/`);

  const authenticatedRequest =
    token && isAdminRequest
      ? request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        })
      : request;

  return next(authenticatedRequest).pipe(
    catchError((error) => {
      if (isAdminRequest && error.status === 401) {
        auth.logout();
        void router.navigate(['/admin/login']);
      }
      return throwError(() => error);
    }),
  );
};
